import { Component } from '@angular/core';
import { AEmptyBasePage } from '../empty.base.page';

@Component({
    selector: 'app-empty-layout',
    templateUrl: '../empty.base.page.html',
    styleUrls: ['../empty.base.page.css']
})
export class EmptyLayoutPage extends AEmptyBasePage {
    constructor() {
        super();
        this.pageTitleKey = '@@EmptyLayoutPageTitle';
        this.pageDescriptionKey = '@@EmptyLayoutPageDescription';
        this.settingItems = [
            { icon: 'pi pi-plus-circle', titleKey: '@@EmptyLayoutCreateNewApplication', descriptionKey: '@@EmptyLayoutCreateNewApplicationDesc', link: '/settings/layout/navigation' },
            { icon: 'pi pi-cog', titleKey: '@@EmptyLayoutManageExistingApplications', descriptionKey: '@@EmptyLayoutManageExistingApplicationsDesc', link: '/settings/layout/navigation/navi-overview' },
            { icon: 'pi pi-file', titleKey: '@@EmptyLayoutCreateNewPage', descriptionKey: '@@EmptyLayoutCreateNewPageDesc', link: '/settings/layout/pages' },
            { icon: 'pi pi-list', titleKey: '@@EmptyLayoutViewExistingPages', descriptionKey: '@@EmptyLayoutViewExistingPagesDesc', link: '/settings/layout/pages' },
            { icon: 'pi pi-clone', titleKey: '@@EmptyLayoutCreateNewTemplate', descriptionKey: '@@EmptyLayoutCreateNewTemplateDesc', link: '/settings/layout/templates' },
            { icon: 'pi pi-th-large', titleKey: '@@EmptyLayoutViewExistingTemplates', descriptionKey: '@@EmptyLayoutViewExistingTemplatesDesc', link: '/settings/layout/templates' },
        ];
    }
}
